import { z } from 'zod';
/** Body of `POST /api/v1/push/subscriptions`: `PushSubscription.toJSON()`. */
export const pushSubscriptionInputSchema = z.object({
    endpoint: z.url({ protocol: /^https$/ }).max(2048),
    keys: z.object({
        p256dh: z.string().min(1).max(256),
        auth: z.string().min(1).max(256),
    }),
});
/** Body of `DELETE /api/v1/push/subscriptions`. */
export const pushUnsubscribeInputSchema = z.object({
    endpoint: z.string().min(1).max(2048),
});
//# sourceMappingURL=push.js.map